import { render, staticRenderFns } from "./SchitaDentara.vue?vue&type=template&id=48955411&"
import script from "./SchitaDentara.vue?vue&type=script&lang=js&"
export * from "./SchitaDentara.vue?vue&type=script&lang=js&"
import style0 from "./SchitaDentara.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports